import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQS = [{
  q: '¿Es seguro el pago?',
  a: 'Totalmente. Usamos pasarelas de pago encriptadas con seguridad bancaria. Tus datos nunca se comparten.'
}, {
  q: '¿Cómo recibo el acceso?',
  a: 'Inmediatamente después del pago recibirás un email con el enlace de descarga de todo el material (PDFs).'
}, {
  q: '¿Funciona en Colombia / en cualquier país?',
  a: 'Sí. El eBook es digital y se descarga en cualquier lugar. Las guías de compra incluyen referencias de tiendas colombianas (D1, Éxito, etc.) pero los principios aplican globalmente.'
}, {
  q: '¿Necesito ingredientes raros o caros?',
  a: 'No. Todo el plan está basado en comida real que consigues en el mercado de la esquina o supermercado normal.'
}, {
  q: '¿Tengo que dejar el café o el postre para siempre?',
  a: '¡Para nada! El objetivo es que tú controles cuándo comerlos, no que ellos te controlen a ti. Aprenderás a disfrutarlos sin ansiedad.'
}, {
  q: '¿Y si mi ansiedad es por estrés?',
  a: 'El protocolo aborda la parte fisiológica de la ansiedad. Al estabilizar tu glucosa, tu resistencia al estrés mejora notablemente.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 bg-white" data-id="element-31">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <h2 className="text-3xl font-bold text-center text-secondary mb-10" data-id="element-33">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-34">
          {FAQS.map((faq, i) => <div key={i} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-35">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex justify-between items-center p-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-36">
                <span className="font-bold text-gray-800" data-id="element-37">{faq.q}</span>
                {openIndex === i ? <ChevronUp className="h-5 w-5 text-gray-500" data-id="element-38" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-39" />}
              </button>

              {openIndex === i && <div className="p-4 bg-white text-gray-600 text-sm leading-relaxed border-t border-gray-100" data-id="element-40">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}